export default function ConstructionOverlay() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/40 backdrop-blur-sm">
      <div className="font-bold text-4xl translate text-center text-gray-800">
        Under Construction
      </div>
    </div>
  );
}
